import * as React from 'react';
import { Col, Row, Label } from 'reactstrap';
import ReactMultiTextarea from 'src/packages/react-multi-textarea/ReactMultiTextarea';
import { IEmailConfiguration } from 'src/share/types/emailsConfiguration';
import { useSelector } from 'react-redux';
import { IReduxState } from 'src/reduxTypes';

export interface IEmailConfigurationProps {
  emailConfiguration: IEmailConfiguration;
  onHandleSelected: (e: string[] | boolean | string, field: string) => void;
}

const EmailConfiguration: React.SFC<IEmailConfigurationProps> = (props) => {
  const { emailConfiguration, onHandleSelected } = props;
  const agencies = useSelector((state: IReduxState) => state.auth.agencies);
  return (
    <Row className='email-configuration-container'>
      <Col className='col-12'>
        {!!emailConfiguration.usersToSend &&
          <>
            <Row>
              <Col className="col-12">
                <Label className="input-label">Send email to:</Label>
              </Col>
            </Row>
            <Row>
              <Col className="col-12">
                <div className="users-to-send">
                  <ReactMultiTextarea
                    key={emailConfiguration.emailId}
                    elements={emailConfiguration.usersToSend || []}
                    isEmailElement={true}
                    dropdownKeys={{ key: '', value: '' }}
                    autoCompleteValues={[{ key: '', value: '' }]}
                    onChange={(data) => onHandleSelected(data, 'usersToSend')}
                    getLabel={(email: string, index: number, removeElement: (index: number) => void) => {
                      return (
                        <div data-tag={true} key={index}>
                          {email}
                          <span data-tag-handle={true} className="fa fa-times" onClick={(e) => {
                            e.preventDefault();
                            removeElement(index)
                          }} />
                        </div>
                      );
                    }}
                  />
                </div>

              </Col>
            </Row>
          </>}
        {!!emailConfiguration.enabledAgencies &&
          <>
            <Row>
              <Col className="col-12">
                <Label className="input-label">Enabled agencies:</Label>
              </Col>
            </Row>
            <Row>
              <Col className="col-12">
                <div className="agencies">
                  <ReactMultiTextarea
                    key={emailConfiguration.emailId}
                    elements={emailConfiguration.enabledAgencies}
                    isEmailElement={false}
                    dropdownKeys={{ key: 'code', value: 'name' }}
                    autoCompleteValues={agencies}
                    onChange={(data) => onHandleSelected(data, 'enabledAgencies')}
                    getLabel={(element: string, index: number, removeElement: (index: number) => void) => {
                      const agencyInfo = agencies.find(agency => agency.code === element);
                      return (
                        <div data-tag={true} key={index}>
                          {agencyInfo ? agencyInfo.name : 'No existent agency'}
                          <span data-tag-handle={true} className="fa fa-times" onClick={(e) => {
                            e.stopPropagation();
                            removeElement(index)
                          }} />
                        </div>
                      );
                    }} />
                </div>
              </Col>
            </Row>
          </>}
        {emailConfiguration.emailId === "ALERTSCLOSETOEXPIRE" &&
          <>
            <Row>
              <Col className="col-12">
                <Label className="input-label" style={{ marginTop: 10 }}>Disabled agencies:</Label>
              </Col>
            </Row>
            <Row>
              <Col className="col-12">
                <div className="agencies">
                  <ReactMultiTextarea
                    key={emailConfiguration.emailId}
                    elements={emailConfiguration.disabledAgencies || []}
                    isEmailElement={false}
                    dropdownKeys={{ key: 'code', value: 'name' }}
                    autoCompleteValues={agencies}
                    onChange={(data) => onHandleSelected(data, 'disabledAgencies')}
                    getLabel={(element: string, index: number, removeElement: (index: number) => void) => {
                      const agencyInfo = agencies.find(agency => agency.code === element);
                      return (
                        <div data-tag={true} key={index}>
                          {agencyInfo ? agencyInfo.name : 'No existent agency'}
                          <span data-tag-handle={true} className="fa fa-times" onClick={(e) => {
                            e.stopPropagation();
                            removeElement(index)
                          }} />
                        </div>
                      );
                    }} />
                </div>
              </Col>
            </Row>
          </>}
      </Col>
    </Row>
  );
}

export default EmailConfiguration;



// WEBPACK FOOTER //
// ./src/modules/UserSettings/EmailsConfiguration/components/EmailConfiguration.tsx